<template>
  <router-view/>
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville&display=swap');
@import url('https://fonts.googleapis.com/css2?family=EB+Garamond&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Allura&display=swap');

@font-face {
  font-family: "RemsenScript";
  src: local("RemsenScript"),
   url('./assets/fonts/webFonts/RemsenScript/font.woff') format("woff");
}
</style>



